import {ConfirmDialog, confirmDialog}       from "primereact/confirmdialog";
import {classNames}                         from 'primereact/utils';
import React, {useEffect, useState}         from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import AppMenu                              from '../components/AppMenu';
import AppTopbar                            from '../components/AppTopbar';
import api                                  from "../services/api";

import {Autenticado, LiberarToken, RefreshToken, RegistrarToken} from "../services/auth";
import Context                                                   from "../services/context";
import debug                                                     from "../utils/debug";

const SistemaLayout = ({children, telaRestrita = true, ...rest}) => {
    let navegacao = useNavigate();
    let location = useLocation();
    let menuClick = false;
    let topbarItemClick = false;
    const [itensMenu, setItensMenu] = useState([]);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [atualizarMenu, setAtualizarMenu] = useState(false);
    const [profileMode, setProfileMode] = useState('inline');
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [menuMode, setMenuMode] = useState('static');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('filled');
    const [ripple, setRipple] = useState(false);
    const [rotateMenuButton, setRotateMenuButton] = useState(false);
    const [darkMenu, setDarkMenu] = useState(false);
    const [menuActive, setMenuActive] = useState(false);

    let containerClassName = classNames('layout-wrapper', {
        'menu-layout-static'         : menuMode !== 'overlay',
        'menu-layout-overlay'        : menuMode === 'overlay',
        'layout-menu-overlay-active' : overlayMenuActive,
        'menu-layout-slim'           : menuMode === 'slim',
        'menu-layout-horizontal'     : menuMode === 'horizontal',
        'layout-menu-static-inactive': staticMenuDesktopInactive,
        'layout-menu-static-active'  : staticMenuMobileActive,
        'p-input-filled'             : inputStyle === 'filled',
        'p-ripple-disabled'          : !ripple
    });

    useEffect(() => {
        carregarMenu();
    },[]);

    const carregarMenu = async () => {
        await new api().requisitar('get', `/configuracao/menu/carregar`).then((resposta) => {
            let itens = resposta;
            itens.push({
                           label: 'Sair',
                           icon : 'pi pi-power-off'
                       });

            setItensMenu(itens);
            setAtualizarMenu(false);
        }).catch((erro) => {
            debug(erro);
        });

    };

    const aoSair = () => {
        confirmDialog({
                          message        : 'Deseja realmente fazer logoff do sistema?',
                          header         : 'Atenção',
                          icon           : 'pi ',
                          acceptLabel    : 'Sim',
                          acceptClassName: 'p-button-btxpp',
                          rejectLabel    : 'Não',
                          rejectClassName: 'p-button-btxpp p-button-outlined',
                          accept         : () => {
                              LiberarToken();
                              navegacao('/login');
                          },
                      });
    };

    const onDocumentClick = () => {
        if (!topbarItemClick) {
            setActiveTopbarItem(null);
            setTopbarMenuActive(false);
        }

        menuClick = false;
        topbarItemClick = false;
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setRotateMenuButton(false);
        setStaticMenuMobileActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 1024;
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;
        setRotateMenuButton((prev) => !prev);
        setTopbarMenuActive(false);

        if (menuMode === 'overlay') {
            setOverlayMenuActive((prevOverlayMenuActive) => !prevOverlayMenuActive);
        } else {
            if (isDesktop()) {
                setStaticMenuDesktopInactive((prevStaticMenuDesktopInactive) => !prevStaticMenuDesktopInactive);
            } else {
                setStaticMenuMobileActive((prevStaticMenuMobileActive) => !prevStaticMenuMobileActive);
            }
        }

        event.preventDefault();
    };

    const onTopbarMenuButtonClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevTopbarMenuActive) => !prevTopbarMenuActive);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onMenuClick = (event) => {
        if (event.target.innerText.toUpperCase() == 'SAIR') {
            aoSair();
        }
        menuClick = true;
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isMenuVisible = () => {
        if (isDesktop()) {
            if (menuMode === 'static') {
                return !staticMenuDesktopInactive;
            } else if (menuMode === 'overlay') {
                return overlayMenuActive;
            } else {
                return true;
            }
        } else {
            if (staticMenuMobileActive) {
                return true;
            } else if (menuMode === 'overlay') {
                return overlayMenuActive;
            } else {
                return true;
            }
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const onMenuitemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
        }

        if (!event.item.items && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }
    };

    const onRootMenuitemClick = () => {
        setMenuActive((prevMenuActive) => !prevMenuActive);
    };

    let menuClassName = classNames('layout-menu-container', {'layout-menu-dark': darkMenu, 'layout-menu-container-inactive': !isMenuVisible()});

    return (
        <Context.Provider value={[atualizarMenu, setAtualizarMenu]}>
            <React.Fragment>
                <ConfirmDialog/>
                {telaRestrita && !Autenticado() &&
                 <Navigate to="/" state={{from: location}} replace/>
                }

                {!telaRestrita &&
                 <>
                     {children}
                 </>
                }

                {telaRestrita && Autenticado() &&
                 <div>
                     <div className={containerClassName} onClick={onDocumentClick}>
                         <div className="layout-wrapper-content">
                             <AppTopbar
                                 topbarMenuActive={topbarMenuActive}
                                 profileMode={profileMode}
                                 horizontal={true}
                                 activeTopbarItem={activeTopbarItem}
                                 rotateMenuButton={rotateMenuButton}
                                 onMenuButtonClick={onMenuButtonClick}
                                 onTopbarMenuButtonClick={onTopbarMenuButtonClick}
                                 onTopbarItemClick={(e) => debug(e)}
                             />
                             <div className={menuClassName} onClick={onMenuClick}>
                                 <div className="menu-scroll-content">
                                     <AppMenu model={itensMenu} menuMode={menuMode} active={menuActive} onMenuitemClick={onMenuitemClick} onRootMenuitemClick={onRootMenuitemClick}></AppMenu>
                                 </div>
                             </div>
                             <div className="layout-main">
                                 {children}
                             </div>
                         </div>
                     </div>
                 </div>
                }
            </React.Fragment>
        </Context.Provider>
    );
};


export default SistemaLayout;
